import PropTypes from "prop-types";

import {
    getColorClass,
    getScrubbedRating,
    isParentFacingRating,
    RATING_DISPLAY_LABELS
} from "../../utils/teacher/InputRatingUtils";

const RatingBlock = ({ rating }) => {
    const scrubbed = getScrubbedRating(rating);
    if (!isParentFacingRating(scrubbed)) {
        return null;
    }

    return (
        <div className={`rating-block ${getColorClass(scrubbed)}`}>
            <div>{RATING_DISPLAY_LABELS[scrubbed]}</div>
        </div>
    );
};

RatingBlock.propTypes = {
    rating: PropTypes.string
};

RatingBlock.defaultProps = {
    rating: null
};

export default RatingBlock;
